import React from 'react';
import PropTypes from 'prop-types';
import LiveStatsCardContainer from './live-stats-card-container';

const LiveStatsList = ({ cardList, ...props }) => {
    if (!Array.isArray(cardList)) return null;

    return (
        <div className="live-stats-list">
            {
                cardList.map((card) =>
                    <LiveStatsCardContainer
                        key={card.name}
                        model={card}
                        hasViewAll
                        hasAnimation
                        {...props}
                    />)
            }
        </div>
    );
};

LiveStatsList.propTypes = {
    cardList: PropTypes.array,
};

export default LiveStatsList;
